export const customerList = "CUSTOMER_LIST";
export const paymentTermList = "PAYMENT_TERM_LIST";
export const customerLocation = "CUSTOMER_LOCATION";
export const regions = "REGIONS";
export const cities = "CITIES";
export const countries = "COUNTRIES";
export const customerDiscount = "CUSTOMER_DISCOUNT";
export const customerEquipment = "CUSTOMER_EQUIPMENT";
export const customerServiceHistory = "CUSTOMER_SERVICE_HISTORY";
